var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"id":"Consulting"}}),_c('UpgradeBusiness'),_c('Services'),_c('DataTransformation'),_c('Professionals'),_c('Customers'),_c('Partners'),_c('Blog'),_c('GetInTouch')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }